import { isDate, format, parseISO, isBefore } from 'date-fns';
import { validateEmail} from "../global/utils";

const validator = require('validator');
const brnv = require('bank-routing-number-validator');
const creditCardType = require('credit-card-type');

export const validateCardData = (paymentFields, court) => {
    let errors = '';
    const cardTypeVal = creditCardType(paymentFields.cardNumber);
    const cardType = Array.isArray(cardTypeVal) && cardTypeVal.length > 0 ? cardTypeVal[0] : '';
    if (!paymentFields.cardNumber) {
        errors = 'The card number is required';
    } else if (!validator.isCreditCard(paymentFields.cardNumber)) {
        errors = 'The card number is invalid';
    } else {
        if (!cardType || (cardType && cardType.type !== 'visa' && cardType.type !== 'mastercard' &&
                cardType.type !== 'discover' && cardType.type !== 'american-express')) {
            if (cardType && cardType.niceType) {
                errors = `${cardType.niceType} cards are not accepted at CitePay`;
            } else {
                errors = 'Your card is not one of the types accepted at CitePay'
            }
        }
    }
    if (!paymentFields.expDate || !isDate(paymentFields.expDate)) {
        if (errors.length > 2) errors += '; ';
        errors += 'Card expiration date is invalid';
    } else if (isBefore(paymentFields.expDate, new Date())) {
        errors += 'Card expiration date must be in the future'
    }
    if (!paymentFields.cvv2 || (cardType.type === 'american-express' ? paymentFields.cvv2.length !== 4 : paymentFields.cvv2.length !== 3)) {
        if (errors.length > 2) errors += '; ';
        errors += 'cvc is invalid';
    }
    if (court.requireZip && !paymentFields.billingZip) {
        if (errors.length > 2) errors += '; ';
        errors = 'The billing zip/postal code is required';
    }
    if (cardType.type === 'american-express' && !court.allowAmex) {
        if (errors.length > 2) errors += '; ';
        errors += `The ${court.courtName} does not accept American Express`;
    }
    if (paymentFields.email && !validateEmail(paymentFields.email)) {
        if (errors.length > 2) errors += '; ';
        errors += `The email address is invalid`;
    }
    if (court.requireContactInfo && !paymentFields.email && !paymentFields.phone) {
        if (errors.length > 2) errors += '; ';
        errors += `${court.courtName} requires that you enter either an email address or a phone number`;
    }
    return errors;
}

export const validateCheckData = (paymentFields, court) => {
    let errors = '';
    if (!paymentFields.routingNumber) {
        errors = 'The routing number is required';
    } else if (!brnv.ABARoutingNumberIsValid(paymentFields.routingNumber)) {
        errors = 'The routing number is invalid';
    }
    if (! paymentFields.bankAccountNumber || paymentFields.bankAccountNumber.length < 4) {
        if (errors.length > 2) errors += '; ';
        errors += 'The bank account number must contain at least four characters';
    }
    if (paymentFields.email && !validateEmail(paymentFields.email)) {
        if (errors.length > 2) errors += '; ';
        errors += `The email address is invalid`;
    }
    if (court.requireContactInfo && !paymentFields.email && !paymentFields.phone) {
        if (errors.length > 2) errors += '; ';
        errors += `${court.courtName} requires that you enter either an email address or a phone number`;
    }
    return errors;
}

export const validateContactInfoAndZeroCheck = (paymentRequest, court) => {
    let errors = '';
    let totalAmount = paymentRequest.totalAmount;
    if (totalAmount <= 0) {
        errors += 'The payment amount must be greater than zero';
    }
    if (court.requireContactInfo && !paymentRequest.email && !paymentRequest.phone) {
        if (errors) errors += '; ';
        errors += 'Either an email address or a phone number is required';
    }
    if (court.requireAddress && (!paymentRequest.payorAddress || !paymentRequest.payorCity || !paymentRequest.payorState || !paymentRequest.billingZip)) {
        errors += `${errors.length > 0 ? '; ' : ''}All address information is required`;
    }
    return errors;
}

export const getDisplayTime = (timeIn) => {
    if (timeIn) {
        return format(parseISO(timeIn), 'MM/dd/yyyy hh:mm:ss aa')
    }
}

export const getReceiptRequest = (paymentRequest, paymentResponse) => {
    const request = {
        courtId: paymentRequest.courtId,
        retrievalCode: paymentResponse.retrievalCode,
        unpaidBalances: paymentRequest.unpaidBalances ? paymentRequest.unpaidBalances : null,
        paymentPlanId: paymentRequest.paymentPlans && paymentRequest.paymentPlans.length > 0
            ? paymentRequest.paymentPlans[0].planId
            : null
    }
    return JSON.stringify(request);
}

export const getFeeQuery = (court, courtAmt, paymentType) => {
    const query = {
        courtId: court.courtId,
        paymentCategory: 'online',
        paymentType: paymentType,
        courtAmount: courtAmt
    }
    return JSON.stringify(query);
}

export const validateVerify = (verifyFields) => {
    let errors = '';
    if (!verifyFields.channel) {
        errors = 'The contact method is required';
    }
    if (!verifyFields.phone) {
        errors = 'The phone number is required';
    } else if (verifyFields.phone.length < 10) {
        errors = 'The phone number is invalid';
    }
    return errors;
}
